import { Box, Icon, TextLink, Typography } from "@drone-js/core";
import { HStack } from "apps/commons/components/Stack";
import type { SidebarItem, SidebarItemStatusEnum } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { type Path, useNavigate, useParams } from "router";
import { sidebarItemStatusMapper } from "./constants";

interface Props {
    previousStepStatus: SidebarItemStatusEnum;
}

export const SidebarTitle: FunctionComponent<SidebarItem & Props> = ({
    order,
    label,
    status,
    path,
    previousStepStatus,
}) => {
    const { lang, propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId/basics");
    const navigate = useNavigate();

    const handleLinkClick = () => {
        navigate(path as Path, {
            params: {
                lang,
                propertyId,
            },
            state: { shouldRefetch: true },
        });
    };

    return (
        <HStack alignItems="center" gap="8">
            <Box
                borderRadius="max"
                width="20px"
                height="20px"
                backgroundColor={
                    status === sidebarItemStatusMapper.Inactive ? "deprecated.neutral.4" : "product.primary"
                }
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                {status === sidebarItemStatusMapper.Completed ? (
                    <Icon id="fill.symbol.check" size="12" color="base.inverted" />
                ) : (
                    <Typography
                        variant="caption-default"
                        textColor={status === sidebarItemStatusMapper.Inactive ? "base.subtle" : "base.inverted"}
                    >
                        {order}
                    </Typography>
                )}
            </Box>
            {(status !== sidebarItemStatusMapper.Inactive ||
                previousStepStatus === sidebarItemStatusMapper.Completed) && (
                <TextLink
                    textVariant="body-s-strong"
                    hierarchy={status === sidebarItemStatusMapper.Inactive ? "tertiary" : "primary"}
                    label={label}
                    onClick={handleLinkClick}
                    data-element-name="list-your-property-stepper"
                    step-name={label}
                />
            )}
            {status === sidebarItemStatusMapper.Inactive &&
                previousStepStatus !== sidebarItemStatusMapper.Completed && (
                    <Typography variant="body-s-strong" textColor="base.subtle">
                        {label}
                    </Typography>
                )}
        </HStack>
    );
};
